var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBasket = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.5)"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0,
  width: 40,
  height: 40,
  rx: 4,
  transform: "translate(0.5 40) rotate(-90)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.5,8a1,1,0,1,0,0,2h2.18l1.839,9.2a1,1,0,0,0,.981.8H25.156l-.9,3H13.5a1,1,0,0,0,0,2H25a1,1,0,0,0,.958-.713l1.5-5V19.27l2-7A1,1,0,0,0,28.5,11H12.92l-.439-2.2A1,1,0,0,0,11.5,8Zm5.82,10-1-5H27.174l-1.429,5Z",
  transform: "translate(2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.5,29a3,3,0,1,1-.879-2.121A3,3,0,0,1,18.5,29Zm-2,0a1,1,0,1,1-.293-.707A1,1,0,0,1,16.5,29Z",
  transform: "translate(2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M26.167,31.494a3,3,0,1,1,1.1-1.346A3,3,0,0,1,26.167,31.494Zm-1.111-1.663a1,1,0,1,1,.368-.449A1,1,0,0,1,25.056,29.831Z",
  transform: "translate(2)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBasket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/basket.54af0368.svg";
export { ForwardRef as ReactComponent };